import angular = require("angular");
import $ = require("jquery");
import _ = require("lodash");

import {Config} from "../config";
import {SessionService} from "../services/session";
import {EventType} from "../models/data";
import {SuccessController} from "../modals/success";
import {ConfirmController} from "../modals/confirm";
import {LoginController} from "../modals/login";
import {HostMessageController} from "../modals/hostMessage";

import TPL = require("templates");


export class EventController {

  static $inject = [
    "$routeParams",
    "session",
    "$location",
    "$uibModal",
    "$rootScope",
    "$document",
    "$filter",
    "Notification",
    "$scope",
    "$timeout",
    "$sce",
    "$log"
  ];

  hstep = 1;
  mstep = 15;

  minEventDate = new Date();
  maxEventDate = null;

  eventTypeOptions = [
    EventType.PUBLIC,
    EventType.MANUAL,
    EventType.PRIVATE
  ];

  eventId;

  session: SessionService;
  rootScope;
  location;
  filter;
  modal;
  notification;
  sce;
  log;
  loadEventState: number;

  currentModal;
  currentSuccessModal;


  imagePromise;

  shouldPublish: boolean;

  mode: string;
  currentData;

  guestsCount: number;

  currentSponsors;


  editorConfig = {
            sanitize: true,
            toolbar: [
            /*{ name: 'basicStyling', items: ['bold', 'italic', 'underline', 'strikethrough', '-', 'leftAlign', 'centerAlign', 'rightAlign', 'blockJustify', '-'] },
            { name: 'paragraph', items: ['orderedList', 'unorderedList', 'outdent', 'indent', '-'] },*/
            { name: 'doers', items: [/*'removeFormatting',*/ 'undo', 'redo', '-'] },
            /*{ name: 'colors', items: ['fontColor', 'backgroundColor', '-'] },*/
            /*{ name: 'links', items: ['image', 'hr', 'symbols', 'link', 'unlink', '-'] },
            { name: 'tools', items: ['print', '-'] },
            { name: 'styling', items: ['font', 'size', 'format'] },*/
            ]
        };

  availableCities;
  availableDates;
  myReservations;
  timeZones;
  dateLabel;

  constructor($routeParams, session, $location, $modal, $rootScope, $document, filter, notification, $scope, $timeout, $sce, $log) {
    window["EVENTCONTROLLER"] = this;
    this.eventId = $routeParams.id;

    this.session = session;
    this.rootScope = $rootScope;
    this.location = $location;
    this.modal = $modal;
    this.filter = filter;
    this.notification = notification;
    this.sce = $sce;
    this.log = $log;

    var cities = this.session.getAvailableCities()
    cities.splice(0,1);
    this.availableCities = cities

    this.availableDates = [
      {id: "3",date: new Date(2016,9,19,19,0,0,0),label: "10/19/2016"}
    ];
    this.dateLabel;
    this.myReservations = this.session.loadMyReservations();
    this.guestsCount = 1;

    this.rootScope.$on("share_done", () => {
      if(this.currentSuccessModal != null) {
        this.currentSuccessModal.dismiss();
      }
    });

    this.imagePromise = $timeout(false);

    if (this.session.isLogged()){
      this.session.loadTimezones().then(
        (response) => {
          this.timeZones = this.parseTimezones(response);
      });
    }

    if (this.eventId) {
      var currentPath = $location.path();
      if(this.endsWith(currentPath, "edit")) {
        this.mode = "edit";
      } else if(this.endsWith(currentPath, "nourished")) {
        this.mode = "nourished";
      } else if(this.endsWith(currentPath, "guests")) {
        this.mode = "guests";
      } else {
        this.mode = "view";
      }
      this.session.loadEvent(this.eventId).then((eventResponse) => {
        this.session.loadSuggestedEvents();
        //var test = this.session.getData().eventStatus;
        this.currentData = {
          event: eventResponse
        }

        if(this.mode == "edit" || this.mode == "guests") {
          if(eventResponse.created_by_profile.id != this.session.getUserId()) {
            this.goLanding();
          }
        }

        try {
          this.currentData.event.area = {};
          this.currentData.event.area.city = _.find(this.availableCities, {code: eventResponse.area_code});
          this.currentData.event.area.neighborhood = _.find(this.currentData.event.area.city.neighborhoods, {code: eventResponse.neighborhood_code});
          var shortime = eventResponse.timezone.split(" - ");
          this.currentData.event.timezone = {
            id: eventResponse.timezone,
            label: shortime[0]
          };
          //this.currentData.event.timezone = eventResponse.timezone;
        } catch (e) {
          this.log.debug(e);
        }

        this.currentData.event.name = eventResponse.title;
        this.currentData.event.maxseats = eventResponse.number_of_guests_max;

        var dateBegin = SessionService.toDate(eventResponse.event_date, true);
        var hrsMins = eventResponse.event_time.split(":");
        dateBegin.setHours(parseInt(hrsMins[0]));
        dateBegin.setMinutes(parseInt(hrsMins[1]));
        this.currentData.event.begin = dateBegin;

        var dateEnd = new Date(dateBegin.getTime());
        dateEnd.setSeconds(dateEnd.getSeconds() + this.currentData.event.duration);
        this.currentData.event.end = dateEnd;

        this.dateLabel = this.getDateLabel();

        this.currentData.event.price = eventResponse.price_per_person/100;

        if(eventResponse.price_per_person > 0) {
          this.currentData.event.paid = true;
        } else {
          this.currentData.event.paid = false;
        }

        if(eventResponse.event_type != null && eventResponse.event_type == "public") {
          this.currentData.event.eventType = EventType.PUBLIC;
        } else if(eventResponse.event_type != null && eventResponse.event_type == "private") {
          this.currentData.event.eventType = EventType.PRIVATE;
        } else if(eventResponse.event_type != null && eventResponse.event_type == "manual_approval") {
          this.currentData.event.eventType = EventType.MANUAL;
        }

        var alcoholPolicies = [];
        var alcoholPolicy = eventResponse.alcohol_policy;

        if(eventResponse.alcohol_policy != null && eventResponse.alcohol_policy == "host_provides") {
          alcoholPolicies.push(0);
        } else if(eventResponse.alcohol_policy != null && eventResponse.alcohol_policy == "byob") {
          alcoholPolicies.push(1);
        } else if(eventResponse.alcohol_policy != null && eventResponse.alcohol_policy == "alcohol_free") {
          alcoholPolicies.push(2);
        }

        var dietaryRestrictions = [];
        angular.forEach(eventResponse.dietary_restrictions, (dietary_restriction) => {
          if(dietary_restriction == "vegetarian") {
            dietaryRestrictions.push(0);
          } else if(dietary_restriction == "vegan") {
            dietaryRestrictions.push(1);
          } else if(dietary_restriction == "gluten_free") {
            dietaryRestrictions.push(2);
          } else if(dietary_restriction == "kosher") {
            dietaryRestrictions.push(3);
          }
        })

        this.currentData.event.filter = {
          dietTypes: dietaryRestrictions,
          alcoholTypes: alcoholPolicies,
          mealTypes: [],
        }


        //this is used when the host try to publish the dinner from the combo menu from the draft list
        if (this.mode == "guests") {
          if (eventResponse.city && this.hasToSkipNourisment()) {
            this.publishEvent();
          }
        }

        if (this.session.isLogged()){
          this.session.loadSponsors(eventResponse.area_code).then(()=>{
            this.currentSponsors = JSON.parse(JSON.stringify(session.getData().sponsorList));
          });
        }

      }).catch((eventResponse) => {
        if (eventResponse.status == 404){
          this.location.url(Config.error + eventResponse.status);
        }
      });

      /*
      this.session.loadNourishment(this.eventId).then((response) => {
        this.log.debug(response);
        angular.forEach(response.data.data, (nourished) => {
          var valueNumber : number = nourished.amount;
          valueNumber = valueNumber / 100;
          if(nourished.name == "instacart") {
            this.instacart = valueNumber;
          } else if(nourished.name == "plated") {
            this.plated = valueNumber;
          } else if(nourished.name == "freshdirect") {
            this.freshdirect = valueNumber;
          }
        })
      });
      */


      if(this.mode == "view") {
        $document.bind("scroll", function() {
          if($("#details") != null && $('#details').offset() != null) {
            var window_top = $(window).scrollTop();
            var div_details_top = $('#details').offset().top - 20;
            var div_details_bottom = div_details_top + $('#details').parent().height();

            var div_menu_top = $('#menu').offset().top - 20;
            var div_menu_bottom = div_menu_top + $('#menu').parent().parent().height();

            var div_host_top = $('#host').offset().top - 20;
            var div_host_bottom = div_host_top + $('#host').parent().height();

            var menu_list = $('.ot-link-list-container').first().find( "ot-link" );

            var menu_item_details = menu_list.first().find('a');
            var menu_item_menu = $(menu_list.get(1)).find('a');
            var menu_item_host = $(menu_list.get(2)).find('a');

            if (window_top > div_details_top && window_top < div_details_bottom) {
              menu_item_details.addClass('ot-link-active');
            } else {
              menu_item_details.removeClass('ot-link-active');
            }

            if (window_top > div_menu_top && window_top < div_menu_bottom) {
              menu_item_menu.addClass('ot-link-active');
            } else {
              menu_item_menu.removeClass('ot-link-active');
            }

            if (window_top > div_host_top && window_top < div_host_bottom) {
              menu_item_host.addClass('ot-link-active');
            } else {
              menu_item_host.removeClass('ot-link-active');
            }
          }
        });
      }


    } else {
      $document.unbind('scroll');

      //var dateBegin = SessionService.toDate("09/27/2016", true);
      var dateBegin = new Date(2016,9,19,19,0,0,0);
      var beginDate = dateBegin;
      beginDate.setHours(19);
      beginDate.setMinutes(0);

      /*var beginDate = new Date();
      beginDate.setHours(19);
      beginDate.setMinutes(0);*/

      var endDate = new Date();
      endDate.setHours(21);
      endDate.setMinutes(0);


      this.mode = "new";

      this.currentData = {
        event: {
          eventType: EventType.PUBLIC,
          area: {},
          begin: beginDate,
          end: endDate,
          parentAuth: false,
          notes: {
            version: "1",
            first: [],
            second: [],
            third: []
          },
          filter: {
            mealTypes: [],
            alcoholTypes: [],
            dietTypes: []
          },
          alcoholType: "",
          dietTypes: [],
          mealType: ""
        }
      }

      this.dateLabel = this.getDateLabel();

    }
  }

  getDateLabel() {
    var dateLabel = (this.currentData.event.begin.getMonth() + 1) + "/" + this.currentData.event.begin.getDate() + "/" + this.currentData.event.begin.getFullYear();
    return dateLabel;
  }

  toHtml(str) {
    if (!str) {
      return "";
    }

    return str.split('\n').join("<br>");
  }

  hasNeighborhood() {
    if(this.mode=="new" || (this.session.getData().event && typeof this.session.getData().event !== "undefined")) {
      if (this.currentData && typeof this.currentData != "undefined") {
        return this.currentData.event.area && this.currentData.event.area.city &&
            this.currentData.event.area.city.neighborhoods && this.currentData.event.area.city.neighborhoods.length > 0;
      }
    }
  }

  isOther() {
    if(this.mode=="new" || (this.session.getData().event && typeof this.session.getData().event !== "undefined")) {
      if (this.currentData && typeof this.currentData != "undefined") {
        return this.currentData.event.area && this.currentData.event.area.city && this.currentData.event.area.city.code == "OTHER";
        }
    }
  }

  getCurrentData() {
    if (this.mode == "view") {
      return this.session.getData();
    } else {
      return this.currentData;
    }
  }

  trust(html) {
    return this.sce.trustAsHtml(html);
  }

  parseTimezones(res) {
    var result = [];
    var id = "";
    var label = "";

    angular.forEach(res, (value) => {
        result.push({
            id:value[0],
            //label:value[1]
            label:value[1]
        });
    });
    return result;
  }

  goLanding() {
    if (this.getCurrentData().event) {

      var areaCode = this.getCurrentData().event.area_code;
      var area:any = _.find(this.availableCities, {code: areaCode});
      if (area) {
        this.location.url(Config.home + "/" + area.url);
      }
    } else {

      this.location.url(Config.home);
    }
  }

  messageHost() {
    if (this.session.isNotLogging()) {
      this.currentModal = LoginController.openSignupModal(this.modal, this, this.rootScope);
    } else {
      HostMessageController.open(this.modal,this.eventId);
    }
  }

  hideMenuCard() {
    return true;
    /*
      if (this.mode != "view") {
        return false;
      } else {
        if(this.getCurrentData() == null || this.getCurrentData().event == null || this.getCurrentData().event.notes == null) {
          return true;
        } else if(this.getCurrentData().event.notes.first.length == 0 && this.getCurrentData().event.notes.second.length == 0 && this.getCurrentData().event.notes.third.length == 0) {
          return true;
        } else {
          return false;
        }
      }
      */
  }

  goManageUpcoming() {
    this.location.url(Config.manage + "/" + Config.upcoming);
  }

  goManageHosted() {
    this.location.url(Config.manage + "/" + Config.hosted);
  }

  createEvent(form) {
    this.log.debug(form);
    if (form.$valid && this.currentData.event.parentAuth) {
      if(!this.currentData.event.paid) {
        this.currentData.event.price = 0;
      }

      var mealType = "";
      var mealTypes = this.currentData.event.filter.mealTypes;
      if (mealTypes.length > 0) {
        var selectedType = mealTypes[0];
        if (selectedType == 0) {
          mealType = "ordered_in";
        } else if (selectedType == 1) {
          mealType = "cooked";
        } else if (selectedType == 2) {
          mealType = "buffet";
        }
      }
      this.currentData.event.mealType = mealType;

      var alcoholType = "";
      var alcoholTypes = this.currentData.event.filter.alcoholTypes;
      if (alcoholTypes.length > 0) {
        var selectedAlcoholType = alcoholTypes[0];
        if (selectedAlcoholType == 0) {
          alcoholType = "host_provides";
        } else if (selectedAlcoholType == 1) {
          alcoholType = "byob";
        } else if (selectedAlcoholType == 2) {
          alcoholType = "alcohol_free";
        }
      }
      this.currentData.event.alcoholType = alcoholType;

      var dietTypes = [];
      var dietTypesForm = this.currentData.event.filter.dietTypes;
      if (dietTypesForm.length > 0) {
        dietTypesForm.forEach(function(entry) {
          var dietType = "";
          if (entry == 0) {
            dietType = "vegetarian";
          } else if (entry == 1) {
            dietType = "vegan";
          } else if (entry == 2) {
            dietType = "gluten_free";
          } else if (entry == 3) {
            dietType = "kosher";
          }

          if(dietType.length > 0) {
              dietTypes.push(dietType);
          }
        });
      }
      this.currentData.event.dietTypes = dietTypes;

      //var timezone = "";
      //timezone = this.currentData.event.area.city.timezone
      /*
      if (this.lastUploadedImage) {
        this.isUploading = true;
        this.uploadCurrentPercentual = 0;

        this.session.uploadFile(this.lastUploadedImage,
          (progress) => {
            this.uploadCurrentPercentual = (progress.loaded / progress.total) * 100;
        })
        .then((result) =>{
          this.isUploading = false;

          this.currentData.event.image = result;
          this.createEventInternal(this.currentData);
        });
      } else {
        this.createEventInternal(this.currentData);
      }
      */

      this.imagePromise().then((result) => {
        this.log.debug(result);
        if (result) {
          this.currentData.event.coverUpdate = result;
        }

        return this.createEventInternal(this.currentData);
      });

    } else {
      this.shouldPublish = false;

      if(this.currentData.event.paid && this.currentData.event.price == null) {
        this.notification.error("Insert a valid price");
      }
    }
  }

  publishEvent() {
    this.log.debug("publishEvent");

    this.session.publishEvent(this.eventId).then((result) => {
      this.session.spinnerService.hide("mainSpinner");
      this.showConfirmModal(this.eventId);
      this.shouldPublish = false;
    });
  }

  getMaxNourishmentAllocation() : number {
    if(this.getCurrentData() != null && this.getCurrentData().event != null) {
      var maxAmount = this.getCurrentData().event.expected_guests * 15;
      maxAmount = Math.min(maxAmount, 150);
      return maxAmount;
    } else {
      return 0;
    }
  }

  submitAllocation(form) {
    this.log.debug("submitAllocation");
    this.log.debug(form);

    if (form.$valid) {
      var amount = this.getAllocated();
      var maxAmount = this.getMaxNourishmentAllocation();
      //maxAmount = Math.max(maxAmount, 150);

      if(amount > maxAmount) {
        this.notification.error("You can assign at most $" + maxAmount + ".00");
      } else {
        this.session.saveNourishment(this.eventId, this.guestsCount, this.currentSponsors).then((response) => {
          if(this.getCurrentData().event.state != "published") {
            this.session.publishEvent(this.eventId).then((result) => {
              this.showConfirmModal(this.eventId);
              this.shouldPublish = false;
            });
          } else {
            this.notification.success("Nourished updated");
          }
        })
      }
    } else {
        this.notification.error("You have to type a number on input!");
    }
  }

  submitGuests(form) {
    this.log.debug("submitGuests");
    this.log.debug(form);

    this.session.saveExpectedGuest(this.eventId, this.guestsCount + 1)
    .then((response) => {
      this.location.url(Config.events + "/" + this.eventId + "/nourished" );
    });
  }

  setPublish(form) {
  if (form.$valid) {
    this.log.debug("setPublish");
    this.shouldPublish = true;
  } else {
    $('html, body').animate({scrollTop : 0},300);
  }
  }

  getCurrentEventDate() : any {
    if(this.getCurrentData() != null && this.getCurrentData().event != null && this.getCurrentData().event.event_date != null) {
      var date = SessionService.toDate(this.getCurrentData().event.event_date, true);
      date.setDate(date.getDate()-5);

      var now = new Date();
      if (now > date) {
        return this.filter('date')(now,'longDate');
      } else {
        return this.filter('date')(date,'longDate');
      }
    } else {
      return "";
    }
  }

  private createEventInternal(currentData) {
    if(this.eventId != null) {
      this.session.spinnerService.show("mainSpinner");
      return this.session.updateEvent(this.currentData.event, this.eventId).then((result) => {
        if(this.shouldPublish) {

          if (this.hasToSkipNourisment()) {
            this.publishEvent();
          } else {
            this.session.spinnerService.hide("mainSpinner");
            this.location.url(Config.events + "/" + this.eventId + "/guests" );
          }

        } else {
          this.session.spinnerService.hide("mainSpinner");
          this.notification.success("Event updated!");
        }
      })
      .catch((error) => {
        this.notification.error("Cannot update event");
        this.session.spinnerService.hide("mainSpinner");
      });
    } else {
      this.session.spinnerService.show("mainSpinner");
      return this.session.createEvent(this.currentData.event).then((result) => {
        var eventId = result.data.data.uuid;
        this.eventId = eventId;
        if(this.shouldPublish) {

          if (this.hasToSkipNourisment()) {
            this.publishEvent();
          } else {
            this.session.spinnerService.hide("mainSpinner");
            this.location.url(Config.events + "/" + eventId + "/guests" );
          }
        } else {
          this.session.spinnerService.hide("mainSpinner");
          this.notification.success("Draft saved!");
          this.location.url(Config.events + "/" + eventId + "/edit" );
        }
      }).catch((error) => {
        if (error.status === 422) {
          this.notification.error("Oops! You cannot create a dinner in the past");
          this.session.spinnerService.hide("mainSpinner");
        }
      });
    }

  }

  private hasToSkipNourisment() {
      if (!this.currentData.event.area || this.session.isOnward()) {
        return true; //TODO ?
      }

      var unnourishables = _.filter(this.availableCities, {nourishment: false});

      //true if the city is one of the list in the array
      var found = !!_.find(unnourishables, {code: this.currentData.event.area.city.code});
      return found;
  }

  private showConfirmModal (eventId) {
    this.location.url(Config.events + "/" + eventId);

    this.currentSuccessModal = this.modal.open({
      controller: () => new SuccessController(this.session),
      controllerAs: "vm",
      replace: true,
      size: "md",
      template: TPL.modals.success
    });
  }

  addSeat() {
    this.guestsCount++;
  }

  removeSeat() {
    if(this.guestsCount > 1) {
      this.guestsCount--;
    }
  }


  getAllocated() {
    var total = _.reduce(this.currentSponsors, function(sum, n) {
      var value = parseFloat(n['currentValue']);
      return isNaN(value) ? sum : sum + value;
    }, 0);

    return total;
  }

  getAllocatedClass() {
    if(this.getAllocated() == 0) {
      return "ot-gray-text";
    } else if(this.getAllocated() > this.getMaxNourishmentAllocation()) {
      return "ot-red-border";
    } else {
      return "";
    }
  }

  isDateDisabled(info) {
    if(info.mode == "day") {
      if(info.date.getDay() != 5) {
        return true;
      }
    }

    return false;
  }

  hasTypes() {
    if(this.getCurrentData().event != null) {
      return (this.getCurrentData().event.alcohol_policy.length > 0 || this.getCurrentData().event.dietary_restrictions.length > 0)
    } else {
      return false;
    }
  }

  canAllocateInstacart() : boolean {
    return true;
  }

  canAllocateSeamless() : boolean {
    return true;
  }

  canAllocateEtsy() : boolean {
    return true;
  }

  canAllocateTableSwoon() : boolean {
    return true;
  }

  canAllocateGrowBehold() : boolean {
    return true;
  }

    canAllocateDoorDash() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateLocalMission() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateWholeFoods() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateGoodEggs() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateRainbow() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateTheMarket() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateBiRite() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateThriveMarket() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="SF"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocatePlated() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && (this.currentData.event.area.city.code=="NY" || this.currentData.event.area.city.code=="CHICAGO")){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateFreshDirect() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="NY"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateOurHarvest() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="NY"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateSoomSoom() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="NY"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateSherryLehmann() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && this.currentData.event.area.city.code=="NY"){
          return true;
        }
      } else {
        return false;
      }
    }

    canAllocateDrizly() : boolean {
      if(this.getCurrentData() != null && this.getCurrentData().event != null) {
        if (this.currentData.event.area.city.nourishment==true && (this.currentData.event.area.city.code=="NY" || this.currentData.event.area.city.code=="CHICAGO")){
          return true;
        }
      } else {
        return false;
      }
    }

    endsWith(str, suffix) : boolean {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/event.ts
 **/